import React from 'react';
import HierarchicalGroupSelector from './HierarchicalGroupSelector';
import { uniqBy, sortBy } from 'lodash';

// for each group in the tree, add a `tasksInHierarchy` attribute that contains
// all alertable tasks in that group and its subgroups
const augmentWithTasksInHierarchy = tree => {
  let result = {};

  for (const [groupId, subTree] of Object.entries(tree)) {
    const children = augmentWithTasksInHierarchy(subTree.children || {});

    let tasksInHierarchy = [
      ...(subTree.data.tasks || []),
      ...Object.values(children).flatMap(d => d.data.tasksInHierarchy)
    ];
    tasksInHierarchy = tasksInHierarchy.filter(t => t.alertable);
    tasksInHierarchy = sortBy(uniqBy(tasksInHierarchy, 'id'), 'order');

    result = {
      ...result,
      [groupId]: {
        children,
        data: { ...subTree.data, tasksInHierarchy }
      }
    };
  }

  return result;
};

const HierarchicalGroupTasksSelector = ({ groupsTree, parentGroupId, selectedTasks, onChange, label }) => (
  <HierarchicalGroupSelector
    groupsTree={augmentWithTasksInHierarchy(groupsTree)}
    parentGroupId={parentGroupId}
    selected={selectedTasks}
    onChange={onChange}
    attribute={'tasksInHierarchy'}
    label={label}
  />
);

export default HierarchicalGroupTasksSelector;
